import { useContext } from "react";
import PropTypes from "prop-types";

import { replaceEmojiShortcodes } from "../../helpers/emojiMap";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseCompanyName = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const companyName = company.fields.companyName;
	if (!companyName) return null;

	return <div className={className}>{replaceEmojiShortcodes(companyName)}</div>;
};

export default BaseCompanyName;

BaseCompanyName.propTypes = {
	className: PropTypes.string,
};
